define(
		'AAMS.OffersExtension.Offers.Countries.View',
		[
		'SCView', 
		'aams_offersextension_offers_countries_dropdown.tpl',
		'Profile.Model',
		'Utils'
		],
	function(
		SCViewComponent, 
		aams_offersextension_offers_countries_dropdown_tpl,
		ProfileModel,
		Utils
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function NewsletterCountriesView(options) {
			SCView.call(this);
			this.options = options || {};
			this.template = aams_offersextension_offers_countries_dropdown_tpl;	
			this.selectedCountry = this.options.selectedCountry
			//console.log(this)	
		}

		// Inherit parent instance methods.
		NewsletterCountriesView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		NewsletterCountriesView.prototype.constructor = NewsletterCountriesView;

		NewsletterCountriesView.prototype.getContext = function() {
			var countries = this.options.countries
			,   selectedCountryName = ''

			var self = this;

			//console.log(countries)

	        var profile = ProfileModel.getInstance()
			,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'

			_.each(countries,function(country){
            	if(country.name == self.selectedCountry){
            		selectedCountryName = country.name
            		//country.isActive = true;
            	}
            });

            //console.log(selectedCountryName)
			return {
				countries: _.values(countries),
	        	isLoggedIn : is_logged_in,
	        	selectedCountryName : selectedCountryName,
	        	hasDefaultCountry : selectedCountryName ? true : false
			}
		}

		// Return the AMD constructor.
		return NewsletterCountriesView;
	}
);
